import axios from 'axios'

export function createProfileActions(state) {
    const { user, permissionsReceived, permissions } = state

    function getUser(userData) {
        user.value = userData
    }

    function getUserPermissionsSuccess(data) {
        permissionsReceived.value = true
        permissions.value = data
    }

    function getUserPermissions() {
        return axios
            .get('/users/permissions')
            .then((response) => {
                const list = response?.data?.results ?? response?.data ?? []
                localStorage.setItem('receivedPermissions', 'true')
                localStorage.setItem('userPermissions', JSON.stringify(list))
                getUserPermissionsSuccess(list)
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    }

    return {
        getUser,
        getUserPermissions
    }
}
